import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import './SettingsLayout.css';

export function SettingsLayout(): ReactElement {
  return <Outlet />;
}
